/* global gsap, ScrollTrigger */

/**
 * Use Cases animation
 */
export default function () {
    if (typeof window === 'undefined') return;
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

    gsap.registerPlugin(ScrollTrigger);

    const sections = document.querySelectorAll('.use-cases');
    if (!sections.length) return;

    sections.forEach(function (section) {
        const line = section.querySelector('.use-cases__line');
        const descText = section.querySelectorAll('.use-cases__description p');
        const right = section.querySelector('.use-cases__right');
        const statItems = gsap.utils.toArray('.use-cases__stat-item', section);

        if (!line || !right) return;

        // ─── Initial states ───────────────────────────────────────────────
        gsap.set(line, { scaleY: 0 });
        gsap.set(descText, { opacity: 0 });
        gsap.set(statItems, { opacity: 0 });

        // ─── Timeline ─────────────────────────────────────────────────────
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: right,
                start: 'top 85%',
                once: true,
            },
            defaults: { ease: 'power2.out' },
        });

        // 1. Line grows + description text fades in together
        tl.to(line, { scaleY: 1, duration: 0.6 })
            .to(descText, { opacity: 1, duration: 0.6, ease: 'power1.inOut' }, '<');

        // 2. Stat items appear one by one after description finishes
        tl.to(statItems, {
            opacity: 1,
            duration: 0.4,
            stagger: 0.15,
            ease: 'power1.inOut',
        }, '>-0.1');
    });
}
